var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon Path Group"},React.createElement("path",{"id":"Icon Path","d":"M1 9L5 5L1 1","stroke":"#00121A","strokeOpacity":"0.38","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})));
}

ChevronRight.defaultProps = {"width":"6","height":"10","viewBox":"0 0 6 10","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
